var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrownInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 13.6693C3.31767 13.6693 0.333008 10.6846 0.333008 7.0026C0.333008 3.3206 3.31767 0.335938 6.99967 0.335938C10.6817 0.335938 13.6663 3.3206 13.6663 7.0026C13.6663 10.6846 10.6817 13.6693 6.99967 13.6693ZM6.99967 12.3359C8.41416 12.3359 9.77072 11.774 10.7709 10.7738C11.7711 9.77365 12.333 8.41709 12.333 7.0026C12.333 5.58812 11.7711 4.23156 10.7709 3.23137C9.77072 2.23117 8.41416 1.66927 6.99967 1.66927C5.58519 1.66927 4.22863 2.23117 3.22844 3.23137C2.22824 4.23156 1.66634 5.58812 1.66634 7.0026C1.66634 8.41709 2.22824 9.77365 3.22844 10.7738C4.22863 11.774 5.58519 12.3359 6.99967 12.3359ZM6.33301 3.66927H7.66634V5.0026H6.33301V3.66927ZM6.33301 6.33594H7.66634V10.3359H6.33301V6.33594Z",
    fill: "#674A02"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownInfoIcon);
export default __webpack_public_path__ + "static/media/brown-info-icon.240f20cc66b84bda2f61900ba5b3e481.svg";
export { ForwardRef as ReactComponent };